import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';

// Importações de estilos
import './App.css';
import './styles/components.css';
import './assets/fonts.css';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div>Loading...</div>}>
          <App />
        </Suspense>
      </I18nextProvider>
    </React.StrictMode>
  );
}
